import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Component } from "react";
import {
  automationSessionData,
  selectedAutomation,
  selectedAutomationNode,
  selectedAutomationTreeViewItem,
} from "../../Template/NewTemplateSignals";

export class NodeNameProperty extends Component {
  constructor({ value, handlePropertyChange }) {
    super();
    this.state = {
      value: value,
    };
    this.handlePropertyChange = handlePropertyChange;
  }

  handleNodeNameChange = ({ e }) => {
    this.setState({ value: e.target.value });
    const node = selectedAutomation.value.model.getNode(selectedAutomationNode.value.options.id);
    node.options.name = e.target.value;

    const newModel = selectedAutomation.value.model;

    //make a new model with the updated node
    newModel.removeNode(node);
    newModel.addNode(node);

    automationSessionData.value = automationSessionData.value.map((automation) => {
      if (automation.id === selectedAutomationTreeViewItem.value) {
        return {
          ...automation,
          model: newModel,
        };
      }
      return automation;
    });
  };

  render() {
    return (
      <div
        key={`${selectedAutomationNode.value.options.id}`}
        className="k-my-2 k-mx-2"
      >
        <Label style={{ fontSize: "14px", fontWeight: "600" }}>Name:</Label>
        <Input
          value={this.state.value}
          onChange={(e) => this.setState({ value: e.target.value })}
          onBlur={() => {
            this.handleNodeNameChange({ e: { target: { value: this.state.value } } });
            this.handlePropertyChange({
              e: { target: { value: this.state.value } },
              propertyName: "Name",
            });
          }}
        />
      </div>
    );
  }
}
